import { Injectable, Injector, ErrorHandler } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

import { NotificationService } from '@core/services/notification.service';
import { AuthenticationService } from '@core/auth/authentication.service';
import { environment } from '@env/environment';
import { MAX_UPLOAD_FILE_SIZE_MB } from '@core/config/file-type';
import { HttpStatusEnum } from './http-status';
import { ItemErroResponse } from './http-error';
// import { ChatBlipSharedDataService } from '@shared/components/chat-blip/chat-blip-shared-data.service';
import { MessageService } from '@core/services/message.service';
import { NzModalService } from 'ng-zorro-antd/modal';
import { ModalErro409Component } from '@shared/components/modal-erro-409/modal-erro-409.component';

const ignoreErrors = [
  "Token is not valid",
  ""
]

@Injectable()
export class HttpErrorInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private notificationService: NotificationService,
    private authenticationService: AuthenticationService,
    // private chatBlipSharedDataService: ChatBlipSharedDataService,
    private messageService: MessageService,
    private modalService: NzModalService
  ) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      tap(null, (err: any) => {
        if (request.url.indexOf(environment.auth) == -1) {
          if (err instanceof HttpErrorResponse) {
            // Se for erro 409, mostra apenas o modal personalizado e retorna
            if (err.status === 409) {
              alertaInativacaoDominios(this.modalService, err);
              return;
            }

            if (err.status === 413) {
              this.notificationService.error(
                'Arquivo muito grande',
                `O arquivo excede o tamanho máximo permitido (${MAX_UPLOAD_FILE_SIZE_MB} MB). Envie um arquivo menor.`
              );
              return;
            }

            if (err.status === 401) {
              const mensagem = err.error?.mensagem ? err.error.mensagem : 'Usuário não autorizado.';

              this.notificationService.error('Ops...', mensagem)
              this.authenticationService.logout(true);
            }

            else {
              if (request.params && request.params.has('ignoreError')) {

              }
              else
                if (err.statusText == 'Unknown Error') {
                  const isUpload = request.url?.includes('/arquivos');
                  this.notificationService.error(
                    'Ops...',
                    isUpload
                      ? `Falha ao enviar o arquivo. Verifique o tamanho (máximo ${MAX_UPLOAD_FILE_SIZE_MB} MB) e se o servidor permite o upload.`
                      : 'Ocorreu um erro inesperado durante esta ação.'
                  )
                }
                else {
                  let errorObj = err.error;

                  if (request.responseType == 'arraybuffer') {
                    if ('TextDecoder' in window) {
                      var dataView = new DataView(err.error);
                      var decoder = new TextDecoder('utf8');
                      errorObj = JSON.parse(decoder.decode(dataView));
                    } else {
                      // var decodedString = String.fromCharCode.apply(null, new Uint8Array(err.error));

                      let uintArray: Uint8Array = err.error;
                      let numberArray: number[] = Array.from(uintArray);
                      let decodedString: string = String.fromCharCode.apply(null, numberArray);

                      errorObj = JSON.parse(decodedString);
                      let errorResponse = <ItemErroResponse[]>errorObj;
                      if (!Array.isArray(errorResponse))
                        errorResponse = [errorResponse];
                      let messages = '';
                      errorResponse.forEach(x => {
                        messages += `${x.mensagem} <br>`;
                      })
                      this.notificationService.warn('Atenção', messages);
                    }
                  }
                  else if (request.responseType == 'blob') {
                    var reader = new FileReader();
                    reader.onload = (ev: any) => {

                      if (typeof ev.target.result == 'string') {
                        try {
                          let jsonError = JSON.parse(ev.target.result);
                          if (!Array.isArray(jsonError))
                            jsonError = [jsonError];

                          let messages = '';
                          jsonError.forEach((x: any) => {
                            messages += `${x.mensagem} <br>`;
                          })
                          this.notificationService.warn('Atenção', messages);
                        } catch {
                          this.notificationService.error('Atenção', ev.target.result);
                        }
                      }
                      else {
                        let errorResponse = <ItemErroResponse[]>errorObj;
                        if (!Array.isArray(errorResponse))
                          errorResponse = [errorResponse];
                        let messages = '';
                        errorResponse.forEach(x => {
                          messages += `${x.mensagem} <br>`;
                        })
                        this.notificationService.warn('Atenção', messages);
                      }
                    }
                    reader.readAsText(errorObj);
                  }
                  else
                    if (err.statusText == 'Unknown Error' || err.status == HttpStatusEnum.Accepted) {
                      this.notificationService.error('Ops...', 'Ocorreu um erro inesperado durante esta ação.')
                    }
                    else if (typeof errorObj === 'string') {
                      const texto = errorObj.trim();
                      const mensagem =
                        texto && !texto.startsWith('<')
                          ? texto
                          : 'Ocorreu um erro inesperado durante esta ação.';
                      this.notificationService.error('Ops...', mensagem);
                    }
                    else {
                      let errorResponse = <ItemErroResponse[]>errorObj;
                      if (!Array.isArray(errorResponse))
                        errorResponse = [errorResponse];

                      let messages = '';

                      errorResponse.forEach(x => {
                        const errosLista = (x as any)?.erros;
                        if (Array.isArray(errosLista) && errosLista.length) {
                          messages += `${errosLista.join('<br>')} <br>`;
                        } else if (x?.mensagem) {
                          messages += `${x.mensagem} <br>`;
                        } else if (x?.message) {
                          messages += `${x.message} <br>`;
                        } else {
                          messages += 'Ocorreu um erro inesperado durante esta ação <br>';
                        }
                      });

                      this.notificationService.warn('Atenção', messages);


                    }
                }
            }
          }
        }
      })
    )
  }
}

function separarPorVirgula(itens: string) {
  return (itens?.match(/(".*?"|[^",]+)(?=\s*,|\s*$)/g) ?? []).map(item => item.replace(/^"|"$/g, ''))

}

export function alertaInativacaoDominios(modalService: NzModalService, err?: any) {
  if (err && err.status === 409) {
    const errorObj = err.error;
    let itens: string[] = [];

    if (errorObj && errorObj.mensagem) {
      // Se a mensagem contém vírgulas, divide em itens separados
      const mensagens = separarPorVirgula(errorObj.mensagem).map((item: string) => item.trim()).filter((item: string) => item);
      itens = mensagens;
    } else if (errorObj && errorObj.message) {
      const mensagens = separarPorVirgula(errorObj.message).map((item: string) => item.trim()).filter((item: string) => item);
      itens = mensagens;
    } else if (Array.isArray(errorObj)) {
      itens = errorObj.flatMap(item => {
        if (typeof item === 'string') {
          return separarPorVirgula(item).map((subItem: string) => subItem.trim()).filter((subItem: string) => subItem);
        } else if (item.mensagem) {
          return separarPorVirgula(item.mensagem).map((subItem: string) => subItem.trim()).filter((subItem: string) => subItem);
        } else if (item.message) {
          return separarPorVirgula(item.message).map((subItem: string) => subItem.trim()).filter((subItem: string) => subItem);
        }
        return ['Item não especificado'];
      });
    } else if (typeof errorObj === 'string') {
      const mensagens = separarPorVirgula(errorObj).map((item: string) => item.trim()).filter((item: string) => item);
      itens = mensagens;
    } else {
      itens = ['Erro não especificado'];
    }

    const modal: any = modalService.create({
      nzTitle: 'Atenção!',
      nzWidth: 800,
      nzStyle: { top: '10vh' },
      nzBodyStyle: {
        'max-height': '70vh',
        'overflow-y': 'auto'
      },
      nzContent: ModalErro409Component,
      nzData: {
        itens: itens
      },
      nzFooter: [
        {
          label: 'Fechar',
          type: 'primary',
          onClick: () => modal.destroy()
        }
      ],
      nzClosable: true,
      nzMaskClosable: true
    });

    modal.componentInstance!.tituloSingular = 'Não é possível inativar este domínio.';
    modal.componentInstance!.tituloPlural = 'Não é possível inativar esses domínios.';
  }
}
